<script setup lang="ts">
// Confirm step for a £0/refund MTA — binds via /payment/bindwithouttransaction, skipping Stripe.
import Modal from '@/components/Common/Modal.vue';

const props = defineProps<{ modelValue: boolean; quoteRef: string; amount: number; isMonthly?: boolean; instalment?: number; prevInstalment?: number; busy?: boolean }>();
defineEmits<{ (e: 'confirm'): void; (e: 'close'): void }>();

const money = (n: number) => `£${Math.abs(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
</script>

<template>
    <Modal :modelValue="modelValue" modalName="noPaymentNeededModal" :tempOperatorScriptVue="true" @close="$emit('close')">
        <template #header><h5 class="modal-title">No payment needed</h5></template>
        <template #body>
            <p v-if="isMonthly && amount < 0" class="mb-3">
                Your monthly payment will decrease from <strong>{{ money(prevInstalment ?? 0) }}</strong>
                to <strong>{{ money(instalment ?? 0) }}</strong>
                <template v-if="prevInstalment"> (a reduction of <strong>{{ money((instalment ?? 0) - (prevInstalment ?? 0)) }}</strong>)</template>.
            </p>
            <p v-else-if="amount < 0" class="mb-3">You will receive a refund of <strong>{{ money(amount) }}</strong>.</p>
            <p class="mb-2">No payment is required at this stage.</p>
            <p class="mb-0">Click continue to finalise the amendment to your policy.</p>
        </template>
        <template #footer>
            <button type="button" class="btn out" :disabled="busy" @click="$emit('close')">
                <em class="far fa-chevron-left mr-1"></em> Back
            </button>
            <button type="button" class="btn pri" :disabled="busy" @click="$emit('confirm')">
                {{ busy ? 'Finalising…' : 'Continue →' }}
            </button>
        </template>
    </Modal>
</template>
